import { Injectable } from '@angular/core';
import { UrlService } from '@draeger-academy/common';
import { StorageMap, JSONSchema } from '@ngx-pwa/local-storage';
import { CookieService } from 'ngx-cookie-service';
import moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';

/* generate Array<{ name: string; value: any }> */
const Schema : JSONSchema = {
    type: "array",
    items: [ {
        type: "object",
        properties: {
            name: { type: "string" },
            value: { type: "string" },
        }
     }
    ]
};

@Injectable()
export class PrepopulationHandlingService {
    private readonly _cookieName = 'hubspotutk';
    private readonly _storageName = 'hubspotutk_storage_academy';
    private readonly _idKey = 'dw_ls_id';
    private readonly _dateKey = 'dw_ls_date';
    private _$lsData: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(private _cookieService: CookieService, private _localStorage: StorageMap, private _urlService: UrlService) {}

    public get lsData$(): Observable<any> {
        return this._$lsData.asObservable();
    }

    public checkStorageValidity(): Promise<any> {
        return new Promise<void>((resolve) => {
            this._localStorage.get(this._urlService.decode(this._storageName), Schema).subscribe({next: (data: any) => {
                let _data = null;
                if (data) {
                    _data = this._urlService.decode(data);
                }
                if (_data) {
                    this._$lsData.next(JSON.parse(_data));
                } else {
                    this._$lsData.next([]);
                }
                this._checkIfCoolieExistsOrDelete();
                this._checkIfStorageExpirationTimeReachedAndDelete();
                resolve();
            }});
        });
    }

    public setLocalStorage(formData: any) {
        const _id = this._cookieService.get(this._cookieName);
        const _currentStorage = this.getDataFromStorage();
        const _data = formData.fields;
        let _cleanData = _currentStorage.filter((item) => item.name !== this._idKey && item.name !== this._dateKey);
        _data.forEach((d) => {
            _cleanData = _cleanData.filter((el) => el.name !== d.name);
        });

        if (_data) {
            _data.push({ name: this._idKey, value: _id });
            _data.push({ name: this._dateKey, value: moment().format() });
            this._localStorage
                .set(this._storageName, this._urlService.encode(JSON.stringify(_cleanData.concat(_data))))
                .subscribe((data) => {});
        }
    }

    public getDataFromStorage() {
        return this._$lsData.getValue();
    }

    private _deleteStorage() {
        this._localStorage.delete(this._storageName);
    }

    private _checkIfCoolieExistsOrDelete() {
        const _hasValidCookie = this._cookieService.get(this._cookieName);
        if (!_hasValidCookie) {
            this._deleteStorage();
        }
        if (_hasValidCookie && this._$lsData.getValue()) {
            const _idFromStorage = this._$lsData.getValue().filter((obj) => {
                return obj.name === this._idKey;
            });
            if (_idFromStorage[0] && _idFromStorage[0].value !== _hasValidCookie) {
                this._deleteStorage();
            }
        }
    }

    private _checkIfStorageExpirationTimeReachedAndDelete() {
        const _dateFromStorage = this._$lsData.getValue().filter((obj) => {
            return obj.name === this._dateKey;
        });
        if (_dateFromStorage[0]) {
            if (moment(_dateFromStorage[0].value).add(90, 'days') > moment()) {
                this._deleteStorage();
            }
        }
    }
}
